import React, { useState } from 'react';
import { newsletterApi } from '../services/api';

function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const response = await newsletterApi.subscribe(email);
      setStatus('success');
      setEmail('');
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        setStatus(error.response.data.error);
      } else {
        setStatus('An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newsletter-section">
      <div className="newsletter-container">
        <h3>📧 Get Best Deals in Your Inbox</h3>
        <p>Subscribe to receive exclusive coupons and latest offers!</p>
        
        <form onSubmit={handleSubmit} className="newsletter-form">
          <input
            type="email"
            placeholder="Enter your email..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>

        {status && (
          <p className={`newsletter-status ${status === 'success' ? 'success' : 'error'}`}>
            {status === 'success' 
              ? '✓ Subscribed! Check your email for confirmation.' 
              : status}
          </p>
        )}
      </div>
    </div>
  );
}

export default Newsletter;
